import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';

( function( app ) {
  const COMPONENT = {
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.statistics__card' ).not( '.is-animated' ).each( function( key, component ) {
        let isAnimated = false;

        gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            start: 'top 95%',
            scrub: 0.5,
            onEnter: () => {
              if ( !isAnimated ) {
                numberAnimations( component );
                isAnimated = true;
              }
            },
          },
        } );
      } );

      function formatNumber( num, size ) {
        return parseFloat( num )
            .toFixed( size )
            .toString()
            .replace( /\B(?=(\d{3})+(?!\d))/g, ',' );
      }

      function animateNumber( el, startNum ) {
        const $this = $( el );
        const initialNum = $this.text();
        const endNum = parseFloat( initialNum.replace( /,/g, '' ) );
        const size = initialNum.split( '.' )[1] ? initialNum.split( '.' )[1].length : 0;
        const counter = {
          value: startNum,
        };

        gsap.to( counter, {
          value: endNum,
          duration: 4,
          ease: 'power1.out',
          onUpdate: function() {
            $this.text( formatNumber( counter.value, size ) );
          },
          onComplete: function() {
            $this.text( initialNum.replace( /\B(?=(\d{3})+(?!\d))/g, ',' ) );
          },
        } );
      }

      function numberAnimations( el ) {
        $( el ).find( '.increase-num' ).each( function() {
          animateNumber( this, 0 );
        } );

        $( el ).find( '.decrease-num' ).each( function() {
          animateNumber( this, 100 );
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'statistics', COMPONENT );
} )( app );
